import React from 'react';
import PropTypes from 'prop-types';
import NextLink from '../NextLink';
import OpenNewIcon from '../Icons/OpenInNewIcon';

const NewWindowLink = ({ href, children, className, disabled, icon, withIcon, ...rest }) => (
  <NextLink href={href} target="_blank" rel="noopener noreferrer" disabled={disabled} {...rest}>
    {withIcon ? icon : children}
  </NextLink>
);

NewWindowLink.propTypes = {
  href: PropTypes.string.isRequired,
  children: PropTypes.any,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  icon: PropTypes.node,
  withIcon: PropTypes.bool,
};

NewWindowLink.defaultProps = {
  disabled: false,
  withIcon: false,
  icon: <OpenNewIcon />,
};

export default NewWindowLink;
